exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-negative[data-v-118156fd] {\n  font-size: 15px;\n  font-weight: 400;\n  margin-top: 0;\n}\n.oldImage[data-v-118156fd] {\n  max-width: 80%;\n}\n", ""]);

// exports
